import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
//import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ExcelService } from 'src/app/services/Excel.service';


@Component({
  selector: 'app-commande-carte',
  templateUrl: './commande-carte.component.html',
  styleUrls: ['./commande-carte.component.css']
})
export class CommandeCarteComponent implements OnInit {

  titre = 'Commandes Reelles - Cartes recharges';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  items: any[] = [];
  montantTotal:number=0;
  nombreLignes:number=0;
  displaychargement:boolean;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    //let user = this.store.getItem('user');
    console.log("this.store.isUserPartenaire==================="+this.store.isUserPartenaire);
    console.log("this.store.currentUser==================="+JSON.stringify(this.store.currentUser));
    console.log("this.store.currentRole==================="+this.store.currentLogin);
    this.loadSelectList();
  }

  async recherche() {

    if(this.selectedPdg === null || this.selectedPdg === undefined || this.selectedPdg === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    let criteria: CriteriaData = new CriteriaData();
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    criteria.nature = "CARTE";
    console.log(JSON.stringify(criteria));
    this.displaychargement=true;
    try {
      this.items = <any>await this.reportingVenteService.commandes(criteria).toPromise();
    } catch (error) {
      
    }
    
    this.displaychargement=false;
    //console.log('items: ', this.items);

    if(this.items ===null || this.items === undefined) {
      this.items = [];
    }
    this.montantTotal=0;
    this.items.forEach(e => {
      this.montantTotal += Number(e.quantite) * Number(e.valeurFaciale);
    });
    this.nombreLignes = this.items.length;

  }


  async loadSelectList() {
    this.listLogin = [];
    if(this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'PDG...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login, value: el.login });
        }
      } catch (error) { }
    }
    
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });
  }

  async onChangePDG(event) {
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });
    let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
    for (let el of dataRet) {
      this.listMsisdn.push({ label: el.telephone, value: el.telephone });
    }
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }


  async exporter() {
    if(this.items === null || this.items === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if(this.items.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.items.map(entry => ({
        "PDG": entry.loginClient,
        "DATE COMMANDE": entry.dateOperation,
        "COMMANDE": entry.codeCommandeOracle,
        "LIEBLLE VALEUR FACIALE": entry.libelleValeurFaciale,
        "VALEUR FACIALE": entry.valeurFaciale,
        "NUMERO SERIE DEBUT": entry.numeroSerieDebut,
        "NUMERO SERIE FIN": entry.numeroSerieFin,
        "QUANTITE": entry.quantite,
        "MONTANT TOTAL": entry.quantite * entry.valeurFaciale
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.items.length + ' Ligne(s) trouvée(s)' });
  }


  afficheEtat(el){
    if(el.quantite <= 0) {
      return "ANNULE";
    } else {
      return "VALIDE";
    }
  }

}
